(function () {
  'use strict';
  var script = document.currentScript;
  var section = document.getElementById('acbp-' + (script && script.dataset.sectionId));
  if (!section) return;

  // Vor-Reveal-Zustand (Stacks unsichtbar) nur aktivieren, wenn JS läuft —
  // sonst bliebe der CTA-Text ohne JS dauerhaft ausgeblendet.
  section.classList.add('acbp-cta-reveal-ready');

  // Fähigkeits-Flags NICHT hier auswerten: dieses Inline-<script> läuft beim
  // Parsen der Seite, also bevor vendor.min.js/animations.min.js am Body-Ende
  // GSAP + SplitText bereitstellen. Würde man hier cachen, bliebe GSAP_OK
  // dauerhaft false und alle Slide-Übergänge liefen im Hart-Schnitt-Zweig.
  // Neu ausgewertet wird in boot() (window load) — dort ist GSAP verfügbar.
  var GSAP_OK  = false;
  var SPLIT_OK = false;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── CTA-Kachel: Split-Stack-Reveal + Hintergrund-Crossfade ───── */
  var ctaTile     = section.querySelector('.acbp-tile--cta');
  var ctaStack    = ctaTile && ctaTile.querySelector('.acbp-slide-stack[data-role="cta"]');
  var ctaBgLayers = ctaTile ? Array.prototype.slice.call(ctaTile.querySelectorAll('[data-cta-bg-layer]')) : [];
  var ctaBgCur    = 0;

  /* ── Überstand-Headline: exakt auf Kachelbreite einpassen ──────── */
  // Bei aktivem „Überstand" soll die Headline immer die volle Kachelbreite
  // einnehmen (kein Abschneiden am Viewport). Größe wird aus der gemessenen
  // Textbreite berechnet; wird eine Zeile zu klein, darf der Text zweizeilig
  // umbrechen (Wörter bleiben ganz, s. .acbp-cta__stack-word). Läuft bei
  // Reveal, Slide-Wechsel, Resize und nach dem Laden der Schrift.
  function widestLineWidth(el) {
    try {
      var range = document.createRange();
      range.selectNodeContents(el);
      var rects = range.getClientRects();
      var max = 0;
      for (var i = 0; i < rects.length; i++) {
        if (rects[i].width > max) max = rects[i].width;
      }
      return max;
    } catch (e) {
      return el.scrollWidth;
    }
  }

  function fitCtaHeadline() {
    if (!ctaTile || !ctaStack) return;
    var active = ctaStack.querySelector('.acbp-slide-content--active');
    if (!active) return;
    var h3 = active.querySelector('.acbp-cta__headline');
    if (!h3) return;

    h3.style.fontSize = '';
    h3.style.whiteSpace = '';

    if (active.getAttribute('data-cta-overflow') !== 'true') return;

    var targetW = Math.max(0, ctaTile.clientWidth - 2); // 2px Sicherheitsabstand
    if (!targetW) return;

    var MIN = 22;
    var MAX = 240;
    var ONE_LINE_MIN = 30; // darunter lieber zweizeilig

    var base = parseFloat(window.getComputedStyle(h3).fontSize) || 48;

    // 1) Einzeilige Naturbreite messen.
    h3.style.whiteSpace = 'nowrap';
    var oneLineW = widestLineWidth(h3);
    if (!oneLineW) { h3.style.whiteSpace = ''; return; }

    var size = base * (targetW / oneLineW);
    if (size >= ONE_LINE_MIN) {
      h3.style.fontSize = Math.min(MAX, size) + 'px';
      return; // bleibt einzeilig
    }

    // 2) Zweizeilig: iterativ auf die Kachelbreite einpassen.
    h3.style.whiteSpace = 'normal';
    size = Math.max(MIN, Math.min(MAX, 2 * base * (targetW / oneLineW)));
    for (var i = 0; i < 5; i++) {
      h3.style.fontSize = size + 'px';
      var w = widestLineWidth(h3);
      if (!w) break;
      var ratio = targetW / w;
      if (ratio > 0.98 && ratio < 1.02) break;
      size = Math.max(MIN, Math.min(MAX, size * ratio));
    }
    h3.style.fontSize = size + 'px';
  }

  var fitTimer = null;
  window.addEventListener('resize', function () {
    if (fitTimer) clearTimeout(fitTimer);
    fitTimer = setTimeout(fitCtaHeadline, 150);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitCtaHeadline).catch(function () {});
  }

  function ctaBgStyleFrom(el) {
    var c    = el.getAttribute('data-bg-color') || '';
    var grad = el.getAttribute('data-bg-gradient') === 'true';
    var to   = el.getAttribute('data-bg-gradient-to') || '';
    if (!c && !to) return '';
    return grad ? 'linear-gradient(160deg, ' + c + ' 0%, ' + to + ' 100%)' : c;
  }

  // Blendet die Hintergrundfarbe/-verlauf des Ziel-Slides über den inaktiven
  // Layer ein und den bisherigen aus.
  function fadeCtaBg(idx) {
    if (ctaBgLayers.length < 2 || !ctaStack) return;
    var src = ctaStack.querySelector('.acbp-slide-content[data-slide-index="' + idx + '"]');
    if (!src) return;
    var bg = ctaBgStyleFrom(src);
    if (!bg) return;
    var nextLayer = ctaBgCur === 0 ? 1 : 0;
    ctaBgLayers[nextLayer].style.background = bg;
    ctaBgLayers[nextLayer].style.opacity = '1';
    ctaBgLayers[ctaBgCur].style.opacity = '0';
    ctaBgCur = nextLayer;
  }

  // Original-HTML jeder Stack-Zeile cachen, damit der Split-Flap bei jedem
  // Slide-Wechsel neu aufgebaut werden kann (SplitText verändert das DOM).
  var ctaStacksCache = [];
  function cacheCtaStacks() {
    if (!ctaTile) return;
    Array.prototype.forEach.call(ctaTile.querySelectorAll('[data-cta-stack]'), function (el) {
      var rows = Array.prototype.slice.call(el.querySelectorAll('.acbp-cta__stack-row'));
      ctaStacksCache.push({
        el: el,
        rows: rows,
        html: rows.map(function (r) { return r.innerHTML; })
      });
    });
  }

  var ctaTl = null;
  function resetCtaStacks() {
    if (ctaTl) { ctaTl.kill(); ctaTl = null; }
    ctaStacksCache.forEach(function (s) {
      s.rows.forEach(function (r, i) {
        r.style.display = '';
        r.style.transform = '';
        r.innerHTML = s.html[i];
      });
      var wrap = s.el.querySelector('.acbp-cta__stack-rows');
      if (wrap) {
        wrap.style.height = '';
        wrap.style.overflow = '';
        wrap.style.clipPath = '';
      }
      if (GSAP_OK) gsap.set(s.el, { clearProps: 'opacity' });
    });
  }

  // CTA-Reveal am aktiven Slide:
  //  • Headline: Split-Flap (nur die Headline stackt).
  //  • Tagline („Subline"): einfaches Einblenden — kein Stack.
  //  • Tagline-Rahmen: wird per CSS gezeichnet (Klasse --cta-revealed).
  // Tagline + Rahmen laufen komplett über CSS-Transitions und sind damit
  // von der GSAP-Timeline entkoppelt → sie triggern bei JEDEM Slide neu,
  // auch wenn der Flap noch läuft / abgebrochen wird.
  function revealCta() {
    if (!ctaStack) return;
    Array.prototype.forEach.call(
      ctaStack.querySelectorAll('.acbp-slide-content--cta-revealed'),
      function (el) { el.classList.remove('acbp-slide-content--cta-revealed'); }
    );
    var active = ctaStack.querySelector('.acbp-slide-content--active');
    if (!active) return;

    // Overflow (Überstand der Headline) ist pro Slide einstellbar.
    if (ctaTile) ctaTile.classList.toggle('is-overflow', active.getAttribute('data-cta-overflow') === 'true');

    // Headline auf volle Kachelbreite einpassen, bevor der Flap die
    // Zeilenhöhe misst.
    fitCtaHeadline();

    // Tagline + Rahmen sofort per CSS enthüllen (Reflow erzwingt Neustart).
    void active.offsetWidth;
    active.classList.add('acbp-slide-content--cta-revealed');

    if (!SPLIT_OK) return;

    resetCtaStacks();

    var headline = active.querySelector('[data-cta-stack][data-cta-stack-role="headline"]');
    if (!headline) return;

    var wrap = headline.querySelector('.acbp-cta__stack-rows');
    var rows = Array.prototype.slice.call(headline.querySelectorAll('.acbp-cta__stack-row'));
    if (!wrap || rows.length < 2) { gsap.set(headline, { opacity: 1 }); return; }

    // Stack sofort sichtbar (Zeile 0 = korrekter Text) — nie „verschwindet".
    gsap.set(headline, { opacity: 1 });

    if (reduceMotion) {
      wrap.style.height = 'auto';
      wrap.style.clipPath = 'none';
      for (var r = 1; r < rows.length; r++) rows[r].style.display = 'none';
      return;
    }

    var rowH = Math.ceil(rows[0].getBoundingClientRect().height);
    wrap.style.height = rowH + 'px';
    // Nur vertikal clippen — links/rechts darf die Headline rausragen
    // (Overstand-Option). overflow:hidden würde auch horizontal beschneiden.
    wrap.style.overflow = 'visible';
    wrap.style.clipPath = 'inset(0 -100vw 0 -100vw)';

    var splitRows = rows.map(function (row) {
      // words + chars: die Zeichen tragen den Flap, die Wort-Wrapper (CSS:
      // white-space: nowrap) verhindern Umbrüche mitten im Wort bei
      // zweizeiligen Headlines.
      return SplitText.create(row, {
        type: 'words,chars',
        charsClass: 'acbp-cta__stack-char',
        wordsClass: 'acbp-cta__stack-word'
      }).chars;
    });
    var maxChars = Math.max.apply(null, splitRows.map(function (c) { return c.length; }));
    var move = rowH * (rows.length - 1);

    // Wisch-Timing pro Zeichen aus seiner HORIZONTALEN Position ableiten,
    // nicht aus dem Laufindex. Bei einer zweizeilig umbrechenden Headline
    // liefen sonst die Indizes von Zeile 2 hinter denen von Zeile 1 weiter →
    // Zeile 1 wischt komplett durch, dann erst Zeile 2 ("merkwürdig
    // hintereinander"). Über die x-Position (Zeichenmitte relativ zur
    // Zeilenbreite) laufen alle sichtbaren Zeilen synchron von links nach
    // rechts; die Gesamtdauer bleibt konstant, egal wie viele Zeichen.
    var SPREAD = 0.5; // Sekunden von der ersten bis zur letzten Spalte
    var refRect = rows[0].getBoundingClientRect();
    var refW = refRect.width || 1;
    var colDelay = splitRows[0].map(function (ch) {
      var r = ch.getBoundingClientRect();
      var f = (r.left + r.width / 2 - refRect.left) / refW;
      return Math.max(0, Math.min(1, f)) * SPREAD;
    });

    ctaTl = gsap.timeline({
      onComplete: function () {
        // Klappfenster auflösen, damit mehrzeilige Headlines nicht
        // dauerhaft auf eine Zeile beschnitten bleiben.
        wrap.style.height = 'auto';
        wrap.style.clipPath = 'none';
        var last = rows[rows.length - 1];
        var lastChars = last.querySelectorAll('.acbp-cta__stack-char');
        gsap.set(lastChars, { clearProps: 'transform' });
        for (var k = 0; k < rows.length - 1; k++) rows[k].style.display = 'none';
      }
    });

    for (var i = 0; i < maxChars; i++) {
      splitRows.forEach(function (chars, rowIndex) {
        var letter = chars[i];
        if (!letter) return;
        ctaTl.to(letter, { y: -move, duration: 0.5, ease: 'power4.inOut' }, (colDelay[i] || 0) + rowIndex * 0.03);
      });
    }
  }

  function initCtaReveal() {
    if (!ctaTile) return;
    cacheCtaStacks();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        setTimeout(revealCta, 120);
        io.disconnect();
      });
    }, { threshold: 0.2 });
    io.observe(ctaTile);
  }

  /* ── Hauptkachel: Slide-Wechsel per clip-path-Reveal ──────────── */
  // „swipe" = diagonaler Wisch (identische Technik wie die USP-Liste,
  // src/…/academy-usp-list.js › swapImage): beide Ebenen voll gemalt, per
  // z-index gestapelt, nur die Clip-Region wandert → kein Leerframe, kein
  // Overflow, wirkt wie dieselbe Kachel. „radial" = kreisförmiger Gradient-
  // Reveal von der Mitte. „none" / kein GSAP / reduced-motion → hart schneiden.
  var mainStack       = section.querySelector('.acbp-slide-stack[data-role="main"]');
  var mainRevealStyle = section.getAttribute('data-main-reveal') || 'swipe';
  var mainRadialColor = section.getAttribute('data-main-radial-color') || '#00C8B4';
  var mainRadialSoft  = parseFloat(section.getAttribute('data-main-radial-softness')) || 16;
  var mainRadialBlur  = parseFloat(section.getAttribute('data-main-radial-blur'));
  if (isNaN(mainRadialBlur)) mainRadialBlur = 24;
  var mainRevealTl    = null;
  var mainRadialEdge  = null;

  function swapMainReveal(idx, dir) {
    if (!mainStack) return;
    var layers = Array.prototype.slice.call(mainStack.querySelectorAll('.acbp-slide-content'));
    var to = mainStack.querySelector('.acbp-slide-content[data-slide-index="' + idx + '"]');
    if (!to) return;
    var from = mainStack.querySelector('.acbp-slide-content--active');

    if (!from || from === to || !GSAP_OK || mainRevealStyle === 'none' || reduceMotion) {
      layers.forEach(function (l) { l.classList.toggle('acbp-slide-content--active', l === to); });
      section.dispatchEvent(new CustomEvent('acbp:mainslidechange'));
      return;
    }

    if (mainRevealTl) mainRevealTl.kill();
    if (mainRadialEdge) { mainRadialEdge.remove(); mainRadialEdge = null; }
    gsap.killTweensOf(layers);
    layers.forEach(function (l) {
      if (l === to || l === from) return;
      l.classList.remove('acbp-slide-content--active');
      l.style.maskImage = '';
      l.style.webkitMaskImage = '';
      gsap.set(l, { clearProps: 'opacity,visibility,zIndex,clipPath' });
    });

    gsap.set(to,   { opacity: 1, visibility: 'visible', zIndex: 2 });
    gsap.set(from, { opacity: 1, visibility: 'visible', zIndex: 1 });

    var done = function () {
      from.classList.remove('acbp-slide-content--active');
      to.classList.add('acbp-slide-content--active');
      section.dispatchEvent(new CustomEvent('acbp:mainslidechange'));
      gsap.set(from, { clearProps: 'opacity,visibility,zIndex,clipPath' });
      gsap.set(to,   { clearProps: 'opacity,visibility,zIndex,clipPath' });
      to.style.maskImage = '';
      to.style.webkitMaskImage = '';
      from.style.maskImage = '';
      from.style.webkitMaskImage = '';
      if (mainRadialEdge) { mainRadialEdge.remove(); mainRadialEdge = null; }
    };

    if (mainRevealStyle === 'radial') {
      // Weicher/blurry radialer Reveal: der neue Slide wird über eine
      // radial-gradient-Maske mit gefederter Kante enthüllt; ein separater,
      // unscharfer Ring in der Editor-Randfarbe läuft an der Enthüllungskante
      // mit. Kein hartes clip-path → die Kante ist blurry.
      var soft = Math.max(2, mainRadialSoft); // Feder in % der Gradient-Strecke
      mainRadialEdge = document.createElement('div');
      mainRadialEdge.className = 'acbp-main-radial-edge';
      mainRadialEdge.style.filter = 'blur(' + mainRadialBlur + 'px)';
      mainStack.appendChild(mainRadialEdge);

      // Neuer Slide startet komplett maskiert (unsichtbar) — sonst blitzt er
      // vor dem ersten onUpdate-Tick einen Frame lang voll auf.
      var hidden = 'radial-gradient(circle at 50% 50%, #000 0%, #000 0%, rgba(0,0,0,0) 0%)';
      to.style.maskImage = hidden;
      to.style.webkitMaskImage = hidden;

      var p = { r: 0 };
      mainRevealTl = gsap.timeline({ onComplete: done });
      mainRevealTl.to(p, {
        r: 165,
        duration: 0.9,
        ease: 'power2.inOut',
        onUpdate: function () {
          var r = p.r;
          var inner = Math.max(0, r - soft);
          var m = 'radial-gradient(circle at 50% 50%, #000 0%, #000 ' + inner + '%, rgba(0,0,0,0) ' + r + '%)';
          to.style.maskImage = m;
          to.style.webkitMaskImage = m;
          if (mainRadialEdge) {
            mainRadialEdge.style.background =
              'radial-gradient(circle at 50% 50%, rgba(0,0,0,0) ' + Math.max(0, r - soft * 1.6) + '%, ' +
              mainRadialColor + ' ' + r + '%, rgba(0,0,0,0) ' + (r + soft * 1.1) + '%)';
            mainRadialEdge.style.opacity = r > 150 ? String(Math.max(0, (165 - r) / 15)) : '1';
          }
        }
      });
      return;
    }

    // „swipe" — diagonaler Wisch (USP-Listen-Technik). Richtungsabhängig:
    // vorwärts von rechts, rückwärts spiegelverkehrt von links.
    var startTo, endTo, startFrom, endFrom;
    if ((dir || 1) >= 0) {
      startTo   = 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)';
      endTo     = 'polygon(0% 0%, 100% 0%, 100% 100%, -30% 100%)';
      startFrom = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
      endFrom   = 'polygon(0% 0%, 0% 0%, -30% 100%, 0% 100%)';
    } else {
      startTo   = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
      endTo     = 'polygon(0% 0%, 100% 0%, 130% 100%, 0% 100%)';
      startFrom = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
      endFrom   = 'polygon(100% 0%, 100% 0%, 100% 100%, 130% 100%)';
    }

    gsap.set(to, { clipPath: startTo });
    mainRevealTl = gsap.timeline({ defaults: { duration: 0.9, ease: 'power2.inOut' }, onComplete: done });
    mainRevealTl.fromTo(to,   { clipPath: startTo }, { clipPath: endTo })
                .fromTo(from, { clipPath: startFrom }, { clipPath: endFrom }, '<');
  }

  /* ── Detail-Kacheln: Slide-Wechsel per diagonalem Wisch ───────── */
  // Gleiche clip-path-Technik wie der "swipe"-Zweig der Hauptkachel, aber
  // pro Detail-Stack eine eigene Timeline. In goTo() werden die beiden
  // Kacheln zeitlich gegeneinander versetzt angestoßen (Stagger).
  var detailRevealTls = {};

  function swipeStackReveal(stack, idx, dir) {
    if (!stack) return;
    var layers = Array.prototype.slice.call(stack.querySelectorAll('.acbp-slide-content'));
    var to = stack.querySelector('.acbp-slide-content[data-slide-index="' + idx + '"]');
    if (!to) return;
    var from = stack.querySelector('.acbp-slide-content--active');

    if (!from || from === to || !GSAP_OK || reduceMotion) {
      layers.forEach(function (l) { l.classList.toggle('acbp-slide-content--active', l === to); });
      return;
    }

    var role = stack.getAttribute('data-role') || 'detail';
    if (detailRevealTls[role]) detailRevealTls[role].kill();
    gsap.killTweensOf(layers);
    layers.forEach(function (l) {
      if (l === to || l === from) return;
      l.classList.remove('acbp-slide-content--active');
      gsap.set(l, { clearProps: 'opacity,visibility,zIndex,clipPath' });
    });

    gsap.set(to,   { opacity: 1, visibility: 'visible', zIndex: 2 });
    gsap.set(from, { opacity: 1, visibility: 'visible', zIndex: 1 });

    var done = function () {
      from.classList.remove('acbp-slide-content--active');
      to.classList.add('acbp-slide-content--active');
      gsap.set(from, { clearProps: 'opacity,visibility,zIndex,clipPath' });
      gsap.set(to,   { clearProps: 'opacity,visibility,zIndex,clipPath' });
      detailRevealTls[role] = null;
    };

    // Wischrichtung: vorwärts (dir >= 0) enthüllt den neuen Slide von rechts,
    // rückwärts spiegelverkehrt von links — so folgt der Wisch der Navigation.
    var startTo, endTo, startFrom, endFrom;
    if ((dir || 1) >= 0) {
      startTo   = 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)';
      endTo     = 'polygon(0% 0%, 100% 0%, 100% 100%, -30% 100%)';
      startFrom = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
      endFrom   = 'polygon(0% 0%, 0% 0%, -30% 100%, 0% 100%)';
    } else {
      startTo   = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
      endTo     = 'polygon(0% 0%, 100% 0%, 130% 100%, 0% 100%)';
      startFrom = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
      endFrom   = 'polygon(100% 0%, 100% 0%, 100% 100%, 130% 100%)';
    }

    gsap.set(to, { clipPath: startTo });
    var tl = gsap.timeline({ defaults: { duration: 0.7, ease: 'power2.inOut' }, onComplete: done });
    tl.fromTo(to,   { clipPath: startTo }, { clipPath: endTo })
      .fromTo(from, { clipPath: startFrom }, { clipPath: endFrom }, '<');
    detailRevealTls[role] = tl;
  }

  /* ── Video autoplay via IntersectionObserver ───────────────── */
  var videoIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        v.play().catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.1 });
  Array.from(section.querySelectorAll('video.acbp-video')).forEach(function (v) { videoIO.observe(v); });

  /* ── Hauptkachel: Ton an/aus ─────────────────────────────────── */
  // Es hat immer nur GENAU EIN Video Ton: das sichtbare Video des aktiven
  // Slides der Hauptkachel – und nur, wenn der Ton-Button aktiv ist UND die
  // Kachel im Viewport liegt. Alle übrigen Videos (inaktive Slides, die
  // versteckte Desktop/Mobil-Variante, Detail- und CTA-Kacheln) bleiben
  // immer stumm. Vorher entstummte syncSound() ALLE Videos der Hauptkachel
  // auf einmal → bei mehreren Slides liefen mehrere Tonspuren parallel.
  (function initMainMediaControls() {
    var mainTile = section.querySelector('.acbp-tile--main');
    var muteBtn  = mainTile && mainTile.querySelector('[data-acbp-mute]');
    if (!mainTile || !muteBtn || !mainStack) return;

    var soundOn = false; // Default: Ton aus (Videos sind muted für Autoplay)

    function allVideos() {
      return Array.prototype.slice.call(section.querySelectorAll('video.acbp-video'));
    }
    function activeMainVideo() {
      var slide = mainStack.querySelector('.acbp-slide-content--active') || mainStack;
      var vids = Array.prototype.slice.call(slide.querySelectorAll('video.acbp-video'));
      for (var i = 0; i < vids.length; i++) {
        if (vids[i].offsetParent !== null) return vids[i]; // sichtbare (Desktop/Mobil) Variante
      }
      return null;
    }
    function inViewport(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    }

    function syncSound() {
      var target = (soundOn && inViewport(mainTile)) ? activeMainVideo() : null;
      allVideos().forEach(function (v) { v.muted = (v !== target); });
      muteBtn.setAttribute('aria-pressed', String(soundOn));
      muteBtn.setAttribute('aria-label', soundOn ? 'Ton ausschalten' : 'Ton einschalten');
      if (target) target.play().catch(function () {});
    }

    muteBtn.addEventListener('click', function () {
      soundOn = !soundOn;
      syncSound();
    });

    // Slide-Wechsel der Hauptkachel (s. swapMainReveal) → Ton auf das neue
    // aktive Video umhängen; Rein-/Rausscrollen der Kachel → stumm/aktiv.
    section.addEventListener('acbp:mainslidechange', syncSound);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function () { syncSound(); }, { threshold: 0.1 }).observe(mainTile);
    }

    syncSound();
  })();

  /* ── Reveal animation on load — identical params to academy-bento ── */
  var grid = section.querySelector('.acbp-grid');
  var mainTiles = grid ? Array.from(grid.querySelectorAll(':scope > .acbp-tile, :scope > .acbp-right > .acbp-row-top > .acbp-tile, :scope > .acbp-right > .acbp-tile')) : [];
  mainTiles = Array.from(new Set(mainTiles));

  function initReveal() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || !mainTiles.length || !grid) return false;

    if (typeof CustomEase !== 'undefined' && !CustomEase.get('gentleSlow')) {
      CustomEase.create('gentleSlow', 'M0,0,C0.11,0.494,0.192,0.726,0.318,0.852,0.45,0.984,0.504,1,1,1');
    }
    var gsapEase = typeof CustomEase !== 'undefined' ? 'gentleSlow' : 'power2.out';

    gsap.timeline({
      scrollTrigger: { trigger: grid, start: 'top 90%', once: true }
    }).fromTo(mainTiles,
      { opacity: 0, y: 24, scale: 0.85 },
      { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: gsapEase, stagger: 0.16 }
    );

    return true;
  }

  function initRevealFallback() {
    if (!mainTiles.length) return;
    mainTiles.forEach(function (t) { t.style.opacity = '0'; t.style.transform = 'translateY(24px) scale(0.85)'; });
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        mainTiles.forEach(function (t, i) {
          setTimeout(function () {
            t.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            t.style.opacity = '1';
            t.style.transform = 'none';
          }, i * 120);
        });
        revealIO.disconnect();
      });
    }, { threshold: 0.15 });
    revealIO.observe(grid || section);
  }

  function boot() {
    // Erst jetzt (nach window load) sind GSAP + SplitText geladen.
    GSAP_OK  = typeof gsap !== 'undefined';
    SPLIT_OK = GSAP_OK && typeof SplitText !== 'undefined';
    section.classList.toggle('acbp-section--cta-fallback', !SPLIT_OK);

    if (!initReveal()) initRevealFallback();
    initCtaReveal();
    initSlideshow();
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot);
  }

  /* ── Slideshow ──────────────────────────────────────────────── */
  function initSlideshow() {
    if (section.dataset.slideshow !== 'true') {
      console.debug('[acbp] Slideshow inaktiv — "Slideshow aktivieren" ist aus oder es gibt < 2 Slides.');
      return;
    }

    var intervalSec = parseFloat(section.dataset.changeInterval) || 6;

    var stacks = Array.from(section.querySelectorAll('.acbp-slide-stack'));
    if (!stacks.length) {
      console.warn('[acbp] Slideshow: keine .acbp-slide-stack Elemente gefunden.');
      return;
    }
    var slideCount = stacks[0].querySelectorAll('.acbp-slide-content').length;
    if (slideCount < 2) {
      console.warn('[acbp] Slideshow: nur ' + slideCount + ' Slide(s) gefunden, mindestens 2 nötig.');
      return;
    }
    console.debug('[acbp] Slideshow gestartet: ' + slideCount + ' Slides, Intervall ' + intervalSec + 's.');

    var current = 0;

    var dotBtns = Array.prototype.slice.call(section.querySelectorAll('[data-acbp-dot]'));
    var detailStacks = stacks.filter(function (s) {
      return s !== mainStack && s.getAttribute('data-role') !== 'cta';
    });

    var mqMobile = window.matchMedia('(max-width: 1023.98px)');

    function isMobile() { return mqMobile.matches; }

    function next() { goTo((current + 1) % slideCount, 1); }
    function prev() { goTo((current - 1 + slideCount) % slideCount, -1); }

    function updateDots(idx) {
      dotBtns.forEach(function (b) {
        var on = parseInt(b.getAttribute('data-index'), 10) === idx;
        b.classList.toggle('is-active', on);
        if (on) { b.setAttribute('aria-current', 'true'); }
        else { b.removeAttribute('aria-current'); }
      });
    }

    function switchStack(stack, idx) {
      var from = stack.querySelector('.acbp-slide-content--active');
      var to = stack.querySelector('[data-slide-index="' + idx + '"]');
      if (!to || from === to) return;
      if (from) from.classList.remove('acbp-slide-content--active');
      to.classList.add('acbp-slide-content--active');
    }

    function revealCtaStep(idx) {
      switchStack(ctaStack, idx); // CTA-Slide erst aktiv schalten …
      fadeCtaBg(idx);             // … dann Hintergrund überblenden …
      revealCta();                // … dann Headline-Flap + Tagline + Rahmen.
    }

    // Gestaffelte Folgeschritte eines Slide-Wechsels (Desktop). Werden bei
    // einem erneuten goTo() vor Ablauf abgebrochen, damit nichts „nachzappelt".
    var pending = [];
    function clearPending() {
      pending.forEach(function (c) { if (c && c.kill) { c.kill(); } else { clearTimeout(c); } });
      pending = [];
    }
    function after(sec, fn) {
      pending.push(GSAP_OK ? gsap.delayedCall(sec, fn) : setTimeout(fn, sec * 1000));
    }

    // Detail-Kacheln nacheinander anwischen: erste sofort, jede weitere um
    // DETAIL_STAGGER Sekunden versetzt (über after() → wird beim nächsten
    // goTo() sauber abgebrochen).
    var DETAIL_STAGGER = 0.28;
    function swipeDetails(idx, dir, staggered) {
      // Reihenfolge des Versatzes folgt der Wischrichtung: vorwärts obere/
      // erste Kachel zuerst, rückwärts umgekehrt.
      var order = detailStacks.map(function (_, i) { return i; });
      if (dir < 0) order.reverse();
      order.forEach(function (stackIdx, pos) {
        var s = detailStacks[stackIdx];
        if (!staggered || pos === 0) { swipeStackReveal(s, idx, dir); }
        else { after(pos * DETAIL_STAGGER, function () { swipeStackReveal(s, idx, dir); }); }
      });
    }

    // Timing beim Umschalten:
    //  Desktop  → erst die große Kachel, dann (+0.35s) die CTA, dann (+0.7s)
    //             die beiden Detail-Kacheln (mit Stagger zueinander).
    //  Mobil    → alle gleichzeitig (Detail-Kacheln ohne Stagger).
    function goTo(idx, dir) {
      if (idx === current) return;
      if (typeof dir !== 'number' || dir === 0) {
        // Richtung aus der Indexdifferenz ableiten; Wrap-around (0 ↔ letzter
        // Slide) zählt als Schritt in die jeweils „natürliche" Richtung.
        var raw = idx - current;
        if (Math.abs(raw) === slideCount - 1) raw = -raw;
        dir = raw >= 0 ? 1 : -1;
      }
      current = idx;
      clearPending();
      updateDots(idx);

      if (isMobile() || !GSAP_OK || reduceMotion) {
        swapMainReveal(idx, dir);
        revealCtaStep(idx);
        swipeDetails(idx, dir, true);
        return;
      }

      swapMainReveal(idx, dir);
      after(0.35, function () { revealCtaStep(idx); });
      after(0.70, function () { swipeDetails(idx, dir, true); });
    }

    /* ── Auto-Advance: EIN rekursiver setTimeout, nie gestapelt ──── */
    // Läuft nur, wenn weder gehovert noch der Tab verborgen ist UND die
    // Section im/nahe am Viewport ist — sonst tickt der Slide-Wechsel (inkl.
    // seiner GSAP-Clip-Path-Timelines) unbegrenzt weiter, auch längst aus dem
    // Viewport gescrollt (gleiche Klasse von Problem wie das permanente
    // will-change, das academy-gpu-layer-gate.js für andere Sections behebt).
    var timer = null;
    var isHovered = false;
    var isInViewport = true;
    function stopTimer() { if (timer) { clearTimeout(timer); timer = null; } }
    function startTimer() {
      stopTimer();
      if (isHovered || document.hidden || !isInViewport) return;
      timer = setTimeout(function tick() {
        next();
        timer = setTimeout(tick, intervalSec * 1000);
      }, intervalSec * 1000);
    }

    startTimer();
    section.addEventListener('mouseenter', function () { isHovered = true; stopTimer(); });
    section.addEventListener('mouseleave', function () { isHovered = false; startTimer(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stopTimer(); } else { startTimer(); }
    });

    // Skipped in the theme editor: an AJAX section reload can leave the IO
    // observing a transiently zero-size container and never fire again,
    // stalling the slideshow there with nothing to resume it. Same
    // reasoning as the design-mode guards in academy-video-coordinator.js /
    // academy-wipe-slideshow.js.
    var isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    if (!isDesignMode && 'IntersectionObserver' in window) {
      var timerIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isInViewport = entry.isIntersecting;
          if (isInViewport) startTimer();
          else stopTimer();
        });
      }, { rootMargin: '200px 0px' });
      timerIO.observe(section);
    }

    // Navigation: seitliche Desktop-Pfeile UND die der .acbp-mobile-nav
    // (gleiche .flickity-*-Klassen). Nach jedem Klick den Timer neu starten
    // (startTimer stoppt vorher → kein Stapeln, Editor-Intervall bleibt gültig).
    Array.prototype.forEach.call(section.querySelectorAll('.flickity-prev'), function (b) {
      b.addEventListener('click', function () { prev(); startTimer(); });
    });
    Array.prototype.forEach.call(section.querySelectorAll('.flickity-next'), function (b) {
      b.addEventListener('click', function () { next(); startTimer(); });
    });
    dotBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-index'), 10);
        if (!isNaN(i)) { goTo(i); startTimer(); }
      });
    });

    /* ── Touch-Swipe + Trackpad-Wisch über den Kacheln ───────────── */
    var gestureEl = section.querySelector('.acbp-grid') || section;

    // Touch: nur klar horizontale Wische lösen einen Slide-Wechsel aus,
    // vertikale bleiben Seiten-Scroll.
    var tsX = 0, tsY = 0, tsTracking = false;
    gestureEl.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tsTracking = false; return; }
      tsX = e.touches[0].clientX;
      tsY = e.touches[0].clientY;
      tsTracking = true;
    }, { passive: true });
    gestureEl.addEventListener('touchend', function (e) {
      if (!tsTracking) return;
      tsTracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - tsX;
      var dy = t.clientY - tsY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) { next(); } else { prev(); }
        startTimer();
      }
    }, { passive: true });

    // Trackpad: horizontales Wheel (Zwei-Finger-Wisch seitwärts). Vertikales
    // Wheel bleibt unangetastet. Bewusst unempfindlich gehalten, damit ein
    // normaler (leicht schräger) Scroll bzw. der Inertia-Nachlauf des
    // Trackpads keinen ungewollten Slide-Wechsel auslöst:
    //  • deltaX muss deutlich über deltaY liegen (Faktor 1.5, wie beim Touch)
    //  • kleine Deltas (Rauschen) werden ignoriert
    //  • höhere Auslöseschwelle + längere Sperre nach dem Wechsel
    var WHEEL_THRESHOLD = 140; // aufsummierter deltaX bis zum Auslösen
    var WHEEL_COOLDOWN  = 900; // ms Sperre nach einem Wechsel (Inertia abwarten)
    var wheelAccum = 0, wheelCooldown = false, wheelReset = null;
    gestureEl.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY) * 1.5) return; // klar horizontal?
      if (Math.abs(e.deltaX) < 2) return;                        // Rauschen ignorieren
      e.preventDefault();
      if (wheelCooldown) return;
      wheelAccum += e.deltaX;
      if (wheelReset) clearTimeout(wheelReset);
      wheelReset = setTimeout(function () { wheelAccum = 0; }, 120);
      if (Math.abs(wheelAccum) > WHEEL_THRESHOLD) {
        if (wheelAccum > 0) { next(); } else { prev(); }
        startTimer();
        wheelAccum = 0;
        wheelCooldown = true;
        setTimeout(function () { wheelCooldown = false; }, WHEEL_COOLDOWN);
      }
    }, { passive: false });
  }
})();
